/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Product_Not_FoundInputs */

const vi_pos_product_not_found = /** @type {(inputs: Pos_Product_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy sản phẩm`)
};

/**

* @param {Pos_Product_Not_FoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_product_not_found = /** @type {((inputs?: Pos_Product_Not_FoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Product_Not_FoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_product_not_found(inputs)
});